



























































































































































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({})
export default class DocumentSvg extends Vue {
  @Getter("primaryColor") primaryColor;
  @Getter("accentColor") accentColor;
}
